<script setup lang="ts">
/**
 * Возврат из Google (DEV-2122). Экран промежуточный: человек видит его секунду,
 * пока одноразовый код меняется на пару токенов.
 *
 * Адресную строку чистим ДО обмена — код живёт минуту и сгорает при первом
 * использовании, а строка с ним попадает в историю браузера и в закладки.
 * Отказ auth приходит сюда же параметром `sso_error` и показывается на форме
 * входа: свой экран ради одной строки текста заводить незачем.
 */
import { onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'

import { useAuthStore } from '@/features/auth/store'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const auth = useAuthStore()

const backToLogin = (reason: string) => router.replace({ name: 'login', query: { sso_error: reason } })

onMounted(async () => {
  const { code, sso_error: ssoError } = route.query

  if (typeof ssoError === 'string' && ssoError) {
    await backToLogin(ssoError)

    return
  }

  if (typeof code !== 'string' || !code) {
    await backToLogin('failed')

    return
  }

  window.history.replaceState(window.history.state, '', route.path)

  try {
    await auth.loginWithSSOCode(code)
    await router.replace('/my')
  } catch {
    // Обмен не удался чаще всего потому, что код уже сгорел: повторный заход по
    // той же ссылке или второй запрос из-за перезагрузки страницы.
    await backToLogin('code_used')
  }
})
</script>

<template>
  <div class="sso-callback">{{ t('login.sso.pending') }}</div>
</template>

<style scoped>
.sso-callback {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  color: var(--color-text-muted);
  font-size: var(--font-size-body);
  background-color: var(--color-bg-app);
}
</style>
